import React from "react";
import "./About_Banner.css";

function About_Banner() {
  return (
    <div className="about_banner">
      <img
        src="/assets/images/about-us/about-banner.png"
        alt="about_banner"
        className="banner_img"
      ></img>
    </div>
  );
}

export default About_Banner;
